// eslint-disable-next-line simple-import-sort/imports
import React, { useEffect } from 'react';
// libs
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { useAuth } from 'context/AuthContext';
import routes from 'routes';
import { getUserFn } from 'api/authApi';
// components
import FullScreenLoader from 'components/FullScreenLoader';
import SignIn from 'pages/SignIn';

const PrivateRoute = () => {
  const { user, setUser } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const localStorageData = localStorage.getItem('user');
  const userData = localStorageData && JSON.parse(localStorageData);
  const isUser = user && user.appUserId;

  const { isLoading, isFetching } = useQuery(
    ['authUser'],
    () => getUserFn({ AppUserId: userData?.appUserId, Token: userData?.token }),
    {
      enabled: !!userData?.appUserId && !!userData?.token && !isUser, // Only run if user not already loaded
      staleTime: Infinity, // Never become stale
      cacheTime: Infinity, // Keep in cache indefinitely  
      onSuccess: (data) => {
        setUser(data);
      },
    },
  );

  // Redirect employees to Look Like an Account page after successful authentication
  useEffect(() => {
    if (user && user.accessLevel === 'Employee' && location.pathname !== routes.lookLikeAnAccount) {
      navigate(routes.lookLikeAnAccount, { replace: true });
    }
  }, [user, navigate, location.pathname]);

  if (isLoading && isFetching) {
    return <FullScreenLoader />;
  }

  return isUser ? <Outlet /> : <SignIn />;
};

export default PrivateRoute;
